import { mapState, mapGetters, mapActions } from 'vuex';
import lang from './exchange-graph-lang.json';
import exchangeGraphForm from './exchange-graph-form/exchange-graph-form.vue';
import exchangeGraphResults from './exchange-graph-results/exchange-graph-results.vue';
export default {
	data() {
		return {};
	},
	locales: lang,
	components: {
		'exchange-graph-form': exchangeGraphForm,
		'exchange-graph-results': exchangeGraphResults
	},
	computed: {
		...mapState('exchangeGraph', ['technicalError', 'loading', 'currencies', 'results', 'rateType', 'from', 'to', 'rateTypes']),
		...mapGetters('exchangeGraph', ['currencyWithName'])
	},
	methods: {
		onCurrencyChange(model) {
			this.setSelectedCurrency(model.currency);
			if (model.currency) {
				this.getTypes(model);
			}
		},
		...mapActions('exchangeGraph', ['getTypes', 'getCurrencies', 'getGraphData', 'setRateType', 'setFrom', 'setTo', 'setSelectedCurrency'])
	},
	mounted: function () {
		this.getCurrencies();
	}
};
